export default {
  name: 'app'
};